import * as heydoctor from '@goodrx/heydoctor-sdk';
import { get } from 'lodash';
import Alert from 'app/lib/alert';
import Settings from 'app/config/settings';
import { onPromoCodeFailed } from 'app/lib/analytics';

const envMap = {
  dev: heydoctor.Environments.DEVELOPMENT,
  beta: heydoctor.Environments.SANDBOX,
  feature: heydoctor.Environments.SANDBOX,
  prod: heydoctor.Environments.PRODUCTION,
};

const client = new heydoctor.Client({
  env: envMap[Settings.Env],
  apiHost: Settings.Dev || Settings.Beta || Settings.Feature ? Settings.ApiUrl : undefined,
  axiosOptions: {
    headers: Settings.ApiDefaultHeaders,
  },
  clientId: 'heydoctor',
});

export class ConnectivityError extends Error {
  innerError: Error;

  constructor(err: Error) {
    super('Connectivity Error');
    this.innerError = err;
  }
}

client.on('http:success', ({ data, hideSuccessAlert }) => {
  const serverSuccessMessage = get(data, 'message');
  if (!hideSuccessAlert && serverSuccessMessage) {
    Alert.success(serverSuccessMessage);
  }
});

client.on('http:error', ({ statusCode, data, hideErrorAlert }) => {
  if (!statusCode) {
    // connectivity errors don't have a response. these are replaced with
    // a sentinel class so we can ignore them in Sentry.
    throw new ConnectivityError(data);
  }

  const serverErrorMessage = Array.isArray(data) ? data?.[0].message : data?.[0]?.message || data?.message;

  if (!hideErrorAlert && serverErrorMessage) {
    Alert.error(serverErrorMessage);

    if (serverErrorMessage === 'Promotion code is invalid.') {
      onPromoCodeFailed();
    }
  }

  // throw only for 500 error
  if (statusCode === 500) {
    throw serverErrorMessage ? new Error(serverErrorMessage) : data;
  }
});

export default {
  client,

  visits: new heydoctor.Visits(client),
  messages: new heydoctor.Messages(client),
  users: new heydoctor.Users(client),
  services: new heydoctor.Services(client),
  pharmacies: new heydoctor.Pharmacies(client),
  promotions: new heydoctor.Promotions(client),
  files: new heydoctor.Files(client),
  business: new heydoctor.Business(client),
  nps: new heydoctor.NPS(client),
  video: new heydoctor.Video(client),
  legal: new heydoctor.Legal(client),
  address: new heydoctor.Address(client),
  analytics: new heydoctor.Analytics(client),
  education: new heydoctor.Education(client),
};
